import { useState } from "react";
import styled from "styled-components";
import Modal from "../Modal";
import PriceModal from "./PriceModal";

type Props = {
  linkText: string;
  price: {
    [any: string]: string;
  };
};

const LinkPriceListingModal = ({ linkText, price }: Props) => {
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const handleCloseModal = () => setOpenPriceModal(false);
  const handleOpenModal = () => setOpenPriceModal(true);
  return (
    <>
      <StyledLinkText onClick={handleOpenModal}>{linkText}</StyledLinkText>
      {openPriceModal && (
        <Modal
          variant={"none"}
          setOpenOrClose={handleCloseModal}
          width={"270px"}
        >
          <PriceModal setOpenOrClose={handleCloseModal} price={price} />
        </Modal>
      )}
    </>
  );
};

const StyledLinkText = styled.button`
  background: transparent;
  border: none;
  color: #2ca5ff;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Poppins-Medium";
  font-weight: 500;
`;

export default LinkPriceListingModal;
